import styled from 'styled-components'

export  const MovementBox = styled.div`
  width:100%;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  box-shadow :  0px 0px 20px 0px rgb(88 88 88 / 30%);
  border-radius: 18px;
  padding:20px 50px;
  margin-bottom:20px;
  p{
    text-align:center;
    max-width:500px;
  }
`